import styled, { css } from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const StatusesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 44px;
`

export const StatusContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
  z-index: 300;
  max-width: 42px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${props => props.theme.size.L};
  width: ${props => props.theme.size.L};
  background-color: ${props => props.theme.colors.background.secondary};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.disabled.content};
  border-radius: 50%;

  ${props =>
    props.isDone &&
    css`
      background-color: transparent;
      border-color: ${props => props.theme.colors.text.default};
    `};

  ${props =>
    props.isActive &&
    css`
      background-color: ${props.backgroundColor};
      border-color: ${props.backgroundColor};
    `};
`

export const NameAndDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  min-width: 150px;
  top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StatusDivider = styled.div`
  flex-grow: 1;
  border-top: ${props => props.theme.stroke.default} dashed
    ${props => (props.isDone ? props.theme.colors.text.default : props.theme.colors.text.subtle)};
  margin-top: 20px;
  z-index: 20;
`

export const CancelledContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.disabled.surface};
  color: ${props => props.theme.colors.text.inverse};
  padding: ${props => `${props.theme.spacing.sp24} ${props.theme.spacing.sp32}`};
  border-radius: ${props => props.theme.primitives.radius.radius4};
`

export const TrackingNumberAndMenuContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`
